import {InAppService} from 'src/app/services/in-app.service';
import {Config} from './config';
import {Storage} from '@ionic/storage';
import {NavigationStart, Router} from '@angular/router';
import {BasePage} from './pages/base.page';
import {MenuController} from '@ionic/angular';
import {UserService} from './services/user.service';
import {AuthService} from './services/auth.service';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import moment from 'moment';
import 'moment/locale/nl';
import {SplashScreen} from '@awesome-cordova-plugins/splash-screen/ngx';
import {Component, NgZone, OnDestroy, ViewChild} from '@angular/core';
import {PushSubscriptionService} from './services/push-subscription.service';
import {AlertController, IonRouterOutlet, LoadingController, Platform, NavController, ToastController} from '@ionic/angular';
import {register} from 'swiper/element/bundle';
import {OneSignal} from '../cordova/onesignal';

register();

const excluded_routes = [
  '/auth/register',
  '/auth/login',
  '/auth/reset',
  '/auth/newpassword',
  '/auth/verify',
  '/auth/forgot',
  '/terms',
  '/privacy'
];

@Component({
  selector: 'shc-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent extends BasePage implements OnDestroy {
  counter = 0;
  private isCordova = false;
  notificationCount: number;
  @ViewChild(IonRouterOutlet, {static: false}) routerOutlet: IonRouterOutlet;

  constructor(
    platform: Platform,
    protected navController: NavController,
    private router: Router,
    authService: AuthService,
    userService: UserService,
    loadingCtrl: LoadingController,
    toastController: ToastController,
    public menuCtrl: MenuController,
    private oneSignal: OneSignal,
    private splashScreen: SplashScreen,
    protected translate: TranslateService,
    protected alertController: AlertController,
    private readonly pushSubscriptionService: PushSubscriptionService,
    public inAppService: InAppService,
    private ngZone: NgZone
  ) {
    super(platform, userService, authService, translate, loadingCtrl, toastController);
    this.initializeApp();
    this.userService.updatedUser.subscribe(res => {
      console.log('user updated...... at app component constructor....', res);
      this.user = res;
    });
  }

  ngOnDestroy() {
  }

  initializeApp() {
    this.menuCtrl.enable(true);

    this.platform.ready().then(() => {
      console.log('Platform ready');
      this.isCordova = this.platform.is('hybrid');
      if (this.isCordova) {
        this.initOneSignal();
        this.setupBranch();
        this.inAppService.initialize();
        this.splashScreen.hide();
      }

      this.router.events.forEach((event) => {
        if (event instanceof NavigationStart) {
          console.log('Event url: ', event.url);
          if (!excluded_routes.includes(event.url)) {
            this.authService.loggedIn.subscribe((loggedIn) => {
              if (loggedIn) {
                this.userService.getUpdatedUser().subscribe();
              }
            });
          }
        }
      });

      this.platform.backButton.subscribe(() => {
        console.log('Route is: ', this.router.url);
        if (this.routerOutlet && this.routerOutlet.canGoBack() && this.router.url !== '/tabs/home') {
          this.routerOutlet.pop();
        } else if (
          this.router.url === '/tabs/home' || this.router.url === '/auth/login'
        ) {
          this.translate.get(['Buttons.Cancel', 'Buttons.Ok', 'ExitApp', 'ExitConfirm']).subscribe(async messages => {
            const alert = await this.alertController.create({
              header: messages.ExitApp,
              message: messages.ExitConfirm,
              buttons: [
                {
                  text: messages['Buttons.Cancel'],
                },
                {
                  text: messages['Buttons.Ok'],
                  handler: () => {
                    // tslint:disable-next-line: no-string-literal
                    navigator['app'].exitApp();
                  }
                }
              ]
            });
            await alert.present();
          });
        }
      });

      this.translate.setDefaultLang('en');

      const browserLang = this.translate.getBrowserLang();
      if (['en', 'nl'].includes(browserLang)) {
        this.translate.use(browserLang);
      } else {
        this.translate.use('nl');
      }

      this.user$.subscribe(user => {
        if (user) {
          // this.translate.setDefaultLang(user.locale);
          this.translate.use(user.locale);
        // } else {
        //   if (!this.translate.getDefaultLang()) {
        //     this.translate.use('nl');
        //     // this.translate.setDefaultLang('nl');
        //   }
        }
      });

      // Houd moment.js (relatieve tijden zoals "5 minuten geleden") synchroon
      // met de actieve app-taal, inclusief eerste render vóór een eventuele
      // taalwissel.
      moment.locale(this.translate.currentLang);
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        moment.locale(event.lang);
      });

      // Enhance Foreground Link Handling: Subscribe to platform resume
      this.listenForResume();
    });
  }

  private handleBranchResponse(res: any) {
    this.ngZone.run(() => {
      if (res['+clicked_branch_link']) {
        try {
          console.log(res, 'branch data ****');

          let customData: any = {};

          try {
            if (res.customData) {
              if (typeof res.customData === 'string') {
                customData = JSON.parse(res.customData);
              } else {
                customData = res.customData;
              }
            } else if (res.custom_data) {
              if (typeof res.custom_data === 'string') {
                customData = JSON.parse(res.custom_data);
              } else {
                customData = res.custom_data;
              }
            }
          } catch (e) {
            console.error('Failed to parse Branch customData:', e);
          }

          const productId = customData.productId;
          const user_id = customData.user_id;
          const product_id = customData.product_id;
          const type = customData.type;
          const order_id = customData.order_id;

          console.log({productId, user_id, product_id, type, order_id});

          if (productId) {
            console.log('Navigating to product:', productId);
            this.router.navigate(['wardrobe', 'detail', productId]);
          }

          if (user_id && product_id) {
            console.log('Navigating to rate user:', {user_id, product_id, type});
            this.router.navigate([`/rate-user/${user_id}/${type}/${product_id}`]);
          }

          if (order_id) {
            console.log('Navigating to payment success:', {order_id});
            this.router.navigate(['/payment/success'], {
              queryParams: {order_id}
            });
          }
        } catch (err) {
          console.error('Error handling Branch data:', err);
        }
      } else if (res['+non_branch_link']) {
        console.log('Open app with a non Branch deep link: ' + JSON.stringify(res));
        const nonBranchLink = res['+non_branch_link'];
        if (nonBranchLink && nonBranchLink.startsWith('swopster://payment/success')) {
          try {
            const query = nonBranchLink.split('?')[1] || '';
            const params = new URLSearchParams(query);
            const order_id = params.get('order_id');
            const chat_id = params.get('chat_id');
            console.log('Navigating to payment success via custom scheme:', {order_id, chat_id});
            this.router.navigate(['/payment/success'], {
              queryParams: {order_id, chat_id}
            });
          } catch (err) {
            console.error('Error parsing non-branch payment link:', err);
          }
        }
      } else {
        console.log('Open app organically');
      }
    });
  }

  setupBranch() {
    console.log('in setup branch', window['Branch']);
    if (this.platform.is('cordova') && window['Branch']) {
      window['Branch'].initSession()
        .then((res) => this.handleBranchResponse(res))
        .catch((err) => console.error('Branch init error:', err));
    } else {
      console.warn('Branch plugin not available. Are you on a device?');
    }
  }

  listenForResume() {
    this.platform.resume.subscribe(() => {
      console.log('App resumed - checking for pending links');
      if (this.isCordova && window['Branch']) {
        window['Branch'].initSession()
          .then((res) => this.handleBranchResponse(res))
          .catch((err) => console.error('Resume Branch error:', err));
      }
    });
  }

  initOneSignal() {
    if (Config.oneSignalId) {
      // 1) Foreground notification handling
      this.oneSignal.Notifications.onForegroundWillDisplay()
        .subscribe(event => {
          const notification = event.getNotification();
          this.ngZone.run(() => {
            console.log(notification, 'notification:received');
            // events.publish('notification:received', notification);
            // Call API to update notification counter
          });
        });

      this.oneSignal.Notifications.onClick().subscribe((notificationOpened) => {
        const notification = notificationOpened.notification;
        this.ngZone.run(() => {
          console.log(notification, 'onClick notification');
          // events.publish('notification:received', notification);
          const data: Record<string, any> = notification.additionalData;
          if (data && data['additional']) {
            const navObj = data['additional'];

            const args = {};
            for (const key in navObj.params) {
              if (navObj.params[key] !== null && navObj.params[key] !== undefined) {
                args[key] = navObj.params[key];
              }
            }
            this.router.navigate([navObj.path], {
              queryParams: args,
            });
          }
        });
      });

      // 3) Language and initialization
      this.oneSignal.User.setLanguage('nl');
      this.oneSignal.initialize(Config.oneSignalId);

      // 4) Subscription management
      this.authService.onLoginChange.subscribe((loggedIn) => {
        this.oneSignal.User.pushSubscription.getIdAsync().then((id: string) => {
          const deviceId = id ?? null;
          if (deviceId && loggedIn) {
            this.pushSubscriptionService.setSubscription(deviceId);
          } else {
            this.pushSubscriptionService.unsubscribe(deviceId);
          }
        });
      });

      // 5) Request permission if needed
      this.oneSignal.Notifications.getPermissionAsync()
        .then(result => {
          if (!result) {
            return this.oneSignal.Notifications.requestPermission(true);
          }
          return result;
        })
        .then((result) => {
          if (!result) {
            return null;
          }
        })
        .catch(error => {
          console.warn(error);
        });
    }
  }

}
